import type { IBusiness } from '@recargas-dominicanas/core/types';
import { formatId, formatPhone } from '@recargas-dominicanas/core/utils';
import { OutlineCard, TextItem, Title } from '@recargas-dominicanas/core/components';
import { type Style, mergeStyle } from './customer-card.module.css';

interface Props {
  business: IBusiness,
  style?: Style
}

export function CustomerCard(props: Props) {

  const {
    business,
    style: customStyle
  } = props;

  const style = mergeStyle(customStyle);

  return (
    <OutlineCard className={style.container}>
      <div className={style.data}>
        <Title style={style.title} title='Datos del negocio' />
        <TextItem style={style.textItem} title='Nombre' text={business.name} />
        <TextItem style={style.textItem} title='RNC' text={business.rnc} />
        <TextItem style={style.textItem} title='ID' text={formatId(business.id)} />
        <TextItem style={style.textItem} title='Teléfono' text={formatPhone(business.phone)} />
        <TextItem style={style.textItem} title='Correo electrónico' text={business.email} />
        <TextItem style={style.textItem} title='Ciudad' text={business.city} />
        <TextItem style={style.textItem} title='Dirección' text={business.address} />
      </div>
    </OutlineCard>
  );
}
